import type { Audit, Interaction } from "@/types";
import { humanize } from "@/utils/formatters";

export default function StatusBadge({ status }: { status: Audit["status"] | Interaction["status"] }) {
  const statusClasses = {
    queued: "bg-gray-100 text-gray-600",
    completed: "bg-green-100 text-green-600",
    failed: "bg-red-100 text-red-600",
    cancelled: "bg-orange-100 text-orange-600",
    running: "bg-primary/20 text-primary",
    pending: "bg-gray-100 text-gray-600",
  };
  const dotClasses = {
    queued: "bg-gray-500",
    completed: "bg-green-600",
    failed: "bg-red-600",
    cancelled: "bg-orange-600",
    running: "bg-primary",
    pending: "bg-gray-500",
  };

  return (
    <span className={`flex items-center rounded-full px-2.5 py-1 text-xs font-medium ${statusClasses[status]}`}>
      <span className={`mr-1.5 h-2 w-2 rounded-full ${dotClasses[status]}`} />
      {humanize(status)}
    </span>
  );
}
